import { AppState } from '../../init/rootReducer';
import { BrandProfileState } from './slices';

// eslint-disable-next-line import/prefer-default-export
export const getBrandProfileState = (state: AppState): BrandProfileState =>
  state.containers.brandProfile;
